import classes from './InputNumber.module.scss'
import type {
  ChangeEvent,
  KeyboardEvent
} from 'react'

export interface Props {
  isDisabled?: boolean
  isReadOnly?: boolean
  isRequired?: boolean
  isEmptyValueAllowed?: boolean
  label?: string
  max?: number
  min?: number
  onBlur?: () => void
  onChange: (value: number) => void
  onClick?: () => void
  onKeyDown?: (event: KeyboardEvent<HTMLInputElement>) => void
  value?: number
  id?: string
  size?: 'sm' | 'md'
}

const InputNumber = ({
  isDisabled = false,
  isReadOnly = false, // needed to allow click event instead of disabled prop
  isRequired = true,
  isEmptyValueAllowed = false,
  label,
  max = 999,
  min = 0,
  onBlur,
  onChange,
  onClick,
  onKeyDown,
  id,
  size = 'md',
  value = isEmptyValueAllowed
    ? undefined
    : 1
// eslint-disable-next-line complexity
}: Props) => {
  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    onChange(parseInt(event.target.value))
  }

  const className = size === 'sm'
    ? `${classes.InputNumber} ${classes.sm}`
    : classes.InputNumber

  return (
    <input
      aria-label={label}
      className={className}
      disabled={isDisabled}
      id={id}
      max={max}
      min={min}
      onBlur={onBlur}
      onChange={handleChange}
      onClick={onClick}
      onKeyDown={onKeyDown}
      readOnly={isReadOnly}
      required={isRequired}
      type='number'
      value={value}
    />
  )
}

export default InputNumber
